export default function Success() {
    return (
      <div style={{ textAlign: "center", marginTop: 100 }}>
        <h1>🎉 ¡Pago completado con éxito!</h1>
        <p>Gracias por tu compra. Te hemos enviado un correo con los detalles.</p>
        <a href="/" style={{ marginTop: 20, display: "inline-block" }}>Volver a la tienda</a>
      </div>
    );
  }